import { ServerNode } from '~/interfaces/device.interface';

export function getServerNodeFields(serverNode?: ServerNode, outdated?: boolean) {
    const fields = [];
    if (serverNode) {
        if (serverNode.host) {
            fields.push({
                key: 'Host Server',
                value: serverNode.host,
                type: 'string',
                tooltip : 'Cloud server name associated to the gateway'
            });
            if (serverNode.connection) {
                fields.push({
                    key: 'Connection Time',
                    value: serverNode.connection,
                    type: 'date',
                    class: outdated ? 'error--text' : '',
                    tooltip : 'Last connection date to Wifi network',
                });
            }
        } else if (serverNode.disconnection) {
            fields.push({
                key: 'Last Disconnection',
                value: serverNode.disconnection,
                type: 'last_disconnection',
                class: 'error--text',
            });
        }
    }
    return fields;
}
